import type { Locale } from './types'
export default async function getMessages(locale: Locale): Promise<IntlMessages> {
  const mod = (await import(`locales/messages/org/${locale}.json`, { with: { type: 'json' } })) as {
    default: IntlMessages
  }
  return mod.default
}
